import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { TitleBlockComponent } from './title-block/title-block.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';

@Component({
  standalone: true,
  selector: 'app-generate-lod-block',
  templateUrl: './generate-lod-block.component.html',
  styleUrls: ['./generate-lod-block.component.css'],
  imports: [
    TitleBlockComponent,
    ButtonModule,
    DividerModule,
    CommonModule,
    FormsModule,
    ToggleButtonModule 
  ]
})
export class GenerateLodBlockComponent {
  lod = "Nombre de la inspección"

  lod_type = ""

  checked= 0;

   @Input() lob!: any;
    

  getText(text: string, input: HTMLInputElement) {
    if(text) {
      this.lod = ""
      input.value = text.toUpperCase()
    }
    else this.lod = "Nombre de la inspección"
  }
  deleteTrim(text: string, input: HTMLInputElement) {
    text = text.trim()
    input.value = text
  }

  // Instancia del view container para generar los componentes
  @ViewChild('view', { read: ViewContainerRef }) viewContainer!: ViewContainerRef
  // Generamos el componente e instanciamos su observable para eliminarlo
  generate() {
    const component = this.viewContainer.createComponent(TitleBlockComponent)
    this.titles.push(component.instance)
    component.instance.delete.asObservable().subscribe( () =>{
      this.titles = this.titles.filter(item => item != component.instance)
      component.destroy()
    })
    // TODO Agrega una clase al componente generado
    // const element = component.location.nativeElement as HTMLElement
    // element.classList.add('test')
  }

  // La instancia de todos los componentes tipo titulo
  titles: TitleBlockComponent[] = []

}
